<template>
  <qx-card title="列表">
    <PrintDialog ref="printDialog"/>
    <section slot="titleLeft">
      <qx-permpisions permpisions="1006020601">
        <el-button type="primary" @click="() => toOpenPrintDialog(tableData.title,tableData.selectResult)" style="margin-left: 20px">
<!--          <i class="iconfont">&#xe6ab;</i>-->
          打印
        </el-button>
      </qx-permpisions>
    </section>
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn
            :len="tableData.data.length"
            queryUrl="reportActionBO.ajax?cmd=outCarFeeReport"
            :params="fullSearchData"
            bizName="出车打款报销明细导出"
            bizCode="exp202203"
            :excelKeys="excelKeys"
            :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            :height="tableHeight"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55"/>
          <!-- 选择框 end -->
          <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.width || 150"
              :width="item.w"
              :fixed="item.fixed"
              align="center"
          >
            <template v-if="item.children">
              <el-table-column
                  v-for="(childItem, childIndex) in item.children"
                  :key="childIndex"
                  :prop="childItem.prop"
                  :label="childItem.label"
                  :min-width="childItem.width || 160"
                  :width="childItem.w"
              >
                <section  slot-scope="scope">
                  <!-- 订单号码 -->
                  <section v-if="childItem.prop === 'orderId'">
                  <span :class="scope.row.paymentWay !== 2 && scope.row.isVerity === 1?'primary cur':''" @click="toOrderDetail(scope.row)">{{
                      scope.row[scope.column.property]
                    }}</span>
                  </section>
                  <section v-else>{{scope.row[scope.column.property]}}</section>
                  <!-- 订单号码 end -->
                </section>
              </el-table-column>
            </template>
          </el-table-column>
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[10, 20, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import PrintDialog from './printDialog';
import {
  outCarFeeReport,
} from 'api/report';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    PrintDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'orderId',
        title: [ // 表头
          {
            label: '车辆运行基本资料',
            children: [
              {prop: 'orderId', label: '订单号'},
              {prop: 'plateNumber', label: '车牌号码'},
              {prop: 'orgIdName', label: '归属部门'},
              {prop: 'carDriverMan', label: '主驾姓名'},
              {prop: 'copilotMan', label: '副驾姓名'},
              {prop: 'dependTimeStr', label: '发车/靠台时间'},
            ],
          },
          {
            label: '去程船费',
            children: [
              {prop: 'goVoyageFeeStr', label: '去程船费'},
              {prop: 'goVoyageFeeRemark', label: '备注'},
            ],
          },
          {
            label: '回程船费',
            children: [
              {prop: 'returnVoyageFeeStr', label: '回程船费'},
              {prop: 'returnVoyageFeeRemark', label: '备注'},
            ],
          },
          {
            label: '进岛费',
            children: [
              {prop: 'islandEntryFeeStr', label: '进岛费'},
              {prop: 'islandEntryFeeRemark', label: '备注'},
            ],
          },
          {
            label: '现金过路费',
            children: [
              {prop: 'highSpeedFeeStr', label: '现金过路费'},
              {prop: 'highSpeedFeeRemark', label: '备注'},
            ],
          },
          {
            label: '停车费',
            children: [
              {prop: 'parkingFeeStr', label: '停车费'},
              {prop: 'parkingFeeRemark', label: '备注'},
            ],
          },
          {
            label: '维修费',
            children: [
              {prop: 'maintenanceCostStr', label: '维修费'},
              {prop: 'maintenanceCostRemark', label: '备注'},
            ],
          },
          {
            label: '现金加油/气费',
            children: [
              {prop: 'cashForFuelOrGasStr', label: '现金加油/气费'},
              {prop: 'cashForFuelOrGasRemark', label: '备注'},
            ],
          },
          {
            label: '其他费用',
            children: [
              {prop: 'otherExpensesStr', label: '其他费用'},
              {prop: 'otherExpensesRemark', label: '备注'},
            ],
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: outCarFeeReport,
    toOrderDetail (item, defaultActive = '', defaultChildActive = 'carrier', isVerity) {
      if (item.isVerity && item.paymentWay !== 2) {
        this.jump({
          label: `订单详情-${item.orderId}`,
          url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}&defaultActive=${defaultActive}&defaultChildActive=${defaultChildActive}&isVerity=1`,
          full: true,
        });
      }
    },
    toOpenPrintDialog (tableTitle, selectResultArr) { // 选择打印类型
      if (selectResultArr.length === 0) {
        this.$message.warning('请先选择订单！');
      } else {
        let arr = [];
        selectResultArr.map((item) => {
          arr.push(this.formatDate(item.dependTime, 3));
        });
        let chooseMonth = [...new Set(arr)];
        if (chooseMonth.length > 1) {
          this.$message.warning('每次只可选择同一月的订单进行打印！');
        } else {
          this.$refs.printDialog.show(tableTitle, this.$refs.multipleTable.selection);
        }
      }

    },
  },
};
</script>

<style scoped lang="scss">
.isTotal{
  color: red
}
</style>

<style lang="scss">
.el-popover.popoverBackB{
  background: #FFFF00 !important;
}
</style>
